import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin/voip/')({
    head: () => ({ meta: [{ title: 'Voice activation | Phoebe Admin' }] }),
});
